<sc-padding>
  <form [formGroup]="formGroup">
    <sc-string-field labelDictionaryKey="tmc-common.gate-keeping.ui.gate-keeper-control.dialog-find-element-search-field" formControlName="query"></sc-string-field>
    <sc-content-spacer vertical></sc-content-spacer>
    <sc-button fitWidth (click)="executeSearch()" iconClass="fa-magnifying-glass" dictionaryKey="tmc-common.gate-keeping.ui.gate-keeper-control.dialog-find-element-search-button"></sc-button>
  </form>
</sc-padding>
